import getMetaTagContent from '../../helpers/getMetaTagContent';
import { RELAY_API_BASE } from '../../helpers/metaTagIdentifiers';
import errorManager from './errorManager';
import formatError from './formatError';
import pageLoaded from './pageLoaded';

const relayAPI = getMetaTagContent(RELAY_API_BASE);

/**
 * "Massage" the record, enriching it with extra metadata and formatting it, and send.
 * @param {ErrorRecord} payload The request's payload.
 */
const sendError = (payload) => navigator.sendBeacon(`${relayAPI}/v3/relay`, payload);

/**
 * Either send error, or queue up for sending on page load.
 * @param {ErrorRecord} record
 */
const handleError = (record, enrichment = {}) => {
    if (!relayAPI) {
        // Who watches the watchmen? No one. That's who
        return;
    }

    if (!errorManager.shouldReport(record)) {
        return;
    }

    // Object freezing used to convey this record is ready for sending
    const payload = formatError(record, enrichment);

    if (pageLoaded()) {
        sendError(payload);
    } else {
        errorManager.addToQueue(payload);
    }
};

/**
 * Registers window error listeners.
 * returns {function}
 */
const logUnhandledrejectionAndOnerror = () => {
    window.addEventListener(
        'error',
        ({ message, lineno, colno, filename, error = {} } = {}) => {
            error.message = error.message || message;
            error.lineno = error.lineno || lineno;
            error.colno = error.colno || colno;
            error.filename = error.filename || filename;
            handleError(error);
        });

    window.addEventListener(
        'unhandledrejection',
        ({ reason }) => {
            if (!reason) { return; }
            let details = undefined;
            if (typeof reason !== 'object') {
                reason = { message: `${reason}` };
            }
            if (reason.code) {
                details = reason.details || {};
                details.code = reason.code;
            }
            handleError(reason, { code: 'UNHANDLEDREJECTION', details });
        }
    );

    window.addEventListener(
        'load',
        () => {
            errorManager.checkFailedToLoadDependencies();
            errorManager.executeQueue(sendError);
        },
        { once: true }
    );

    return handleError;
};

export default logUnhandledrejectionAndOnerror;
